module.exports = __webpack_public_path__ + "img/5.3d39b131.png";